module.exports = __webpack_public_path__ + "static/media/mess1.0785ed2e.png";